export function isNPO(legalStructure) {
    return legalStructure === '2b9c3eaf-348b-4cf4-bf9e-cd4b8edb0c56';
}
export function isICP(company) {
    return (company.annual_revenue === '5m' ||
        company.annual_revenue === '10m' ||
        company.annual_revenue === '25m' ||
        company.annual_revenue === '50m' ||
        company.annual_revenue === '100m' ||
        company.annual_revenue === '100m+');
}
export const CompanyInitialState = {
    company_id: '',
    name: '',
};
export const CompanyGamePlanInitialState = {
    company_id: '',
    game_plan_id: '',
    account_manager: '',
    asset_id: '',
    file_name: '',
    locale: '',
};
export var CompanyIcpType;
(function (CompanyIcpType) {
    CompanyIcpType["Custom"] = "custom";
    CompanyIcpType["Premium"] = "premium";
    CompanyIcpType["None"] = "none";
})(CompanyIcpType || (CompanyIcpType = {}));
var CompanyAnnualRevenue;
(function (CompanyAnnualRevenue) {
    CompanyAnnualRevenue["annualRevenue1"] = "500k";
    CompanyAnnualRevenue["annualRevenue2"] = "1m";
    CompanyAnnualRevenue["annualRevenue3"] = "2m";
    CompanyAnnualRevenue["annualRevenue4"] = "5m";
    CompanyAnnualRevenue["annualRevenue5"] = "10m";
    CompanyAnnualRevenue["annualRevenue6"] = "25m";
    CompanyAnnualRevenue["annualRevenue7"] = "50m";
    CompanyAnnualRevenue["annualRevenue8"] = "100m";
    CompanyAnnualRevenue["annualRevenue9"] = "100m+";
})(CompanyAnnualRevenue || (CompanyAnnualRevenue = {}));
var CompanySize;
(function (CompanySize) {
    CompanySize["companySize1"] = "1";
    CompanySize["companySize2"] = "2-10";
    CompanySize["companySize3"] = "11-25";
    CompanySize["companySize4"] = "26-50";
    CompanySize["companySize5"] = "51-100";
    CompanySize["companySize6"] = "101-300";
    CompanySize["companySize7"] = "300+";
})(CompanySize || (CompanySize = {}));
export { CompanyAnnualRevenue, CompanySize };
